'use client';

import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { MobileView } from 'react-device-detect';
import { useI18n } from '@locales/client';
import { StyledAlertDialogContent } from '@/features/auth-managment/styles';
import { HeadingMediumH5 } from '@/shared/ui/typography2';
import { Box } from '@/shared/ui/box';
import { useScreenOrientation } from './model/useScreenOrientation';
import { WrapperMain, AnimatedPhoneIcon } from './styles';

const PhoneRotatePrompt = () => {
  const { shouldShow } = useScreenOrientation();
  const t = useI18n();

  return (
    <Dialog.Root open={shouldShow}>
      <MobileView>
        <Dialog.Portal>
          <VisuallyHidden>
            <Dialog.Title>{t('rotate_phone_portrait')}</Dialog.Title>
          </VisuallyHidden>

          <StyledAlertDialogContent>
            <WrapperMain>
              <Box
                $display="flex"
                $flexDirection="column"
                $justifyContent="center"
                $alignItems="center"
                $gap="52px"
                $width="100%"
                $height="100%"
              >
                <AnimatedPhoneIcon
                  width={190}
                  height={115}
                  src="/images/icons/smart-phone-portrait.png"
                  alt="smart-phone-portrait"
                />
                <HeadingMediumH5>{t('rotate_phone_portrait')}</HeadingMediumH5>
              </Box>
            </WrapperMain>
          </StyledAlertDialogContent>
        </Dialog.Portal>
      </MobileView>
    </Dialog.Root>
  );
};

export { PhoneRotatePrompt };
